import { render, staticRenderFns } from "./systemParameterList.vue?vue&type=template&id=1388302e&scoped=true"
import script from "./systemParameterList.vue?vue&type=script&lang=js"
export * from "./systemParameterList.vue?vue&type=script&lang=js"
import style0 from "./systemParameterList.vue?vue&type=style&index=0&id=1388302e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1388302e",
  null
  
)

export default component.exports